import React from "react";
import { AffiliatesApiData } from "../interfaces";
import { AffiliatesLeadCard } from "./AffiliatesLeadCard";
import { formatPrice } from "../../../../helpers/dataConverts";
import { extractNumberFromCurrency } from "../utils";
import { useTranslation } from "react-i18next";

export const AffiliatesLeadCardContainer = ({
  data,
}: {
  data: AffiliatesApiData[];
}) => {
  const { t } = useTranslation(["profile"]);

  const totalEarned = data?.reduce(
    (sum, row) => sum + extractNumberFromCurrency(row.earned),
    0
  );
  const totalPending = data?.reduce(
    (sum, row) => sum + extractNumberFromCurrency(row.pending),
    0
  );

  return (
    <div className="affiliates-lead-card-container">
      {data?.map((leadData, index) => (
        <AffiliatesLeadCard leadData={leadData} key={index} index={index} />
      ))}

      <div className="affiliates-lead-card-container-total-container">
        <div>
          {t("earned")}: ₪{formatPrice(totalEarned)}
        </div>
        <div>
          {t("pending")}: ₪{formatPrice(totalPending)}
        </div>
      </div>
    </div>
  );
};
